import type { ReactElement } from 'react'
import { RemoveScroll } from 'react-remove-scroll'
import { FocusTrap } from '../focusTrap'
import { useDialogContext } from './DialogProvider'

export interface DialogFocusProps {
  children: ReactElement
}

export const DialogFocus = (props: DialogFocusProps): JSX.Element => {
  const {
    autoFocus,
    focusGroup,
    trapFocus,
    dialogRef,
    initialFocusRef,
    blockScrollOnMount,
    allowPinchZoom,
    finalFocusRef,
    returnFocusOnClose,
    preserveScrollBarGap,
    lockFocusAcrossFrames
  } = useDialogContext()

  return (
    <FocusTrap
      group={focusGroup}
      autoFocus={autoFocus}
      isDisabled={!trapFocus}
      initialFocusRef={initialFocusRef}
      finalFocusRef={finalFocusRef}
      restoreFocus={returnFocusOnClose}
      contentRef={dialogRef}
      lockFocusAcrossFrames={lockFocusAcrossFrames}
    >
      <RemoveScroll
        removeScrollBar={!preserveScrollBarGap}
        allowPinchZoom={allowPinchZoom}
        enabled={blockScrollOnMount}
        forwardProps
      >
        {props.children}
      </RemoveScroll>
    </FocusTrap>
  )
}
